import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const Hero = () => {
  return (
    <div className="relative bg-[#FFF9D4] overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#FFB87D] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#FFF9D4] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-[#FF9D57] rounded-full mix-blend-multiply filter blur-3xl opacity-15 animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-[#222222] mb-6 fade-in">
            Rent{' '}
            <span className="text-[#F27D16]">
              Anything
            </span>
            <br />
            You Need
          </h1>
          
          <p className="text-xl md:text-2xl text-[rgba(34,34,34,0.7)] mb-8 max-w-3xl mx-auto fade-in" style={{animationDelay: '0.2s'}}>
            From designer clothes to premium accessories. Discover thousands of items available for rent at unbeatable prices.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center fade-in" style={{animationDelay: '0.4s'}}>
            <Link
              to="/products"
              className="btn-primary flex items-center space-x-2 group"
            >
              <span>Start Renting</span>
              <FiArrowRight className="group-hover:translate-x-1 transition-transform duration-200" />
            </Link>
            <Link
              to="/register"
              className="btn-secondary"
            >
              List Your Items
            </Link>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 fade-in" style={{animationDelay: '0.6s'}}>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#F27D16] mb-2">10K+</div>
              <div className="text-[rgba(34,34,34,0.7)]">Products</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#F27D16] mb-2">5K+</div>
              <div className="text-[rgba(34,34,34,0.7)]">Happy Users</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#F27D16] mb-2">50+</div>
              <div className="text-[rgba(34,34,34,0.7)]">Categories</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#F27D16] mb-2">4.9</div>
              <div className="text-[rgba(34,34,34,0.7)]">Rating</div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes blob {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  );
};

export default Hero;
